import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { BadgeBaseComponent } from './badge-base.component';

@Component({
  selector: 'ptl-clickable-badge',
  templateUrl: './badge-clickable.component.html',
  styleUrls: ['./badge-base.component.scss', './badge-clickable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeClickableComponent extends BadgeBaseComponent {
  cooldown = input<number>(0);

  coolingDown = signal(false);

  isDisabled = computed(() => this.disabled() || this.coolingDown());

  override onClick(): void {
    if (!this.isDisabled()) {
      this.clicked.emit();

      const cooldownMs = this.cooldown();
      if (cooldownMs > 0) {
        this.coolingDown.set(true);
        setTimeout(() => this.coolingDown.set(false), cooldownMs);
      }
    }
  }
}
